module.exports = __webpack_public_path__ + "static/media/phone-rotary.e115061c.svg";